///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, toastSuccessActionCreators, kioskEditImplantationActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postKioskEditImplantation = function* ({ payload }) {
	const bodyMessage = payload.filters

	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_EDIT_IMPLANTATION(payload.requestId, payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMessage)

		yield put(kioskEditImplantationActionCreators.postKioskEditImplantationSuccess(data.data, payload.requestId))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskEditImplantationActionCreators.postKioskEditImplantationFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const getKioskEditImplantationItemsCatalogGrowth = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH(payload.requestId, payload.requestUrl)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskEditImplantationActionCreators.getKioskEditImplantationItemsCatalogGrowthSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskEditImplantationActionCreators.getKioskEditImplantationItemsCatalogGrowthFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postKioskEditImplantationUnitActionWithId = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID(payload.requestId, payload.query, payload.arg)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.caseList)

		yield put(kioskEditImplantationActionCreators.postKioskEditImplantationUnitActionWithIdSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(payload.toast))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskEditImplantationActionCreators.postKioskEditImplantationUnitActionWithIdFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putKioskEditImplantationValidateImplantation = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION(payload.requestId)
	const msgParam = 'toast__kiosk__in__production__modify__implantation__validated'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(kioskEditImplantationActionCreators.putKioskEditImplantationValidateImplantationSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(msgParam))
	} catch (e) {
		if (e.response.data.errorCode === 1) {
			yield put(kioskEditImplantationActionCreators.putKioskEditImplantationValidateImplantationFailure(e.response))
		} else if (e.response.data.errorCode === 2) {
			yield put(kioskEditImplantationActionCreators.putKioskEditImplantationValidateImplantationFailure(e.response))
		} else {
			yield put(errorManagerActionCreators.createError(e.response))
		}
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION, postKioskEditImplantation)
	yield takeLatest(ActionsTypes.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH, getKioskEditImplantationItemsCatalogGrowth)
	yield takeLatest(ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID, postKioskEditImplantationUnitActionWithId)
	yield takeLatest(ActionsTypes.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION, putKioskEditImplantationValidateImplantation)
}

export default sagas
